let printer_BillPrintActions = require("../../templates/printer/BillPrintActions.handlebars");
let BillList = require("../../templates/table/BillList.handlebars");
let BillItem = require("../../templates/table/BillItem.handlebars");
let BillDetails = require("../../templates/table/BillDetails.handlebars");
let $ = require("jquery");
let Backbone = require("backbone");
let _ = require("underscore");
import POS from "../../POS.js";
import i18n from "../../utils/i18n";

let moment = require('moment');
import ModalView from "../comp/ModalView.js";
import Chart from "chart.js"
console.log("chart-----",Chart);

let DbRecorder = require("../../recorder/DbRecorder.js");
let PagingView = require("../comp/PagingView.js");
let PagingModel = require("../../model/PagingModel.js");
import StatsService from "../../service/StatsService.js";
import BillPrintActionsView from "../printer/BillPrintActionsView.js";
import BillRefundModalView from "../table/BillRefundModalView.js";

let BillModel = require("../../model/BillModel.js");
let BillCollection = require("../../collection/BillCollection.js");
import BillMerger from "../../recorder/BillMerger.js";

let datei18n = require("../../utils/utils");
import PrintService from "../../service/PrintService.js";

let PasswordEntry = require("../../templates/pos/comp/PasswordEntry.handlebars");
let PasswordEntryView = require("../comp/PasswordEntryView.js");

let main = function () {
    return Backbone.View.extend({
        billPageView: null,
        printEL: null,
        todayBillCollection: null,
        events: {
            "click .download": 'exportData',
            "click .downloadMail": 'exportData',
            "click .print-record": 'printRecord',
            "click .email": 'exportData',
            "click .nav li": 'selectPanel',
            'click tr.bill': 'showBillPopup',
            //'click .bill .refund': 'refundBill',
            'click .bill .print': 'printBill',
            'click .bill .anti-settlement': 'antiSettlement',
            'click .quickModal .btn-close': '_close',
            'click .quickModal .noTip': '_close',
            'click .searchBar button': 'billSearch',
            'click .billModal .orderitem': 'onBillItemClick',
            'click .billModal .confirm': '_refundItems',
            'click .billModal .print-bill': 'printSearchBill',
            'click .billModal .refund-onlinePay': '_refundOnlinePay',
            'click .billModal .refund-bill': 'showRefundPage',
            'click .billModal .cancel': 'hideRefundPage',
            'click .billModal .selected-all': 'selectAll'
        },

        initialize: function () {
            if (!this.printEL) {
                this.printEL = $(printer_BillPrintActions());
            }
            if (window.AndroidClient) {
                this.$(".download,.download-takeout").addClass("hidden");
            }
            this.todayBillCollection = new Backbone.Collection();
        },

        render: function () {
            this.model = new Backbone.Model();
            this.$(".startTime .time-width").val(moment().startOf("day").format("YYYY-MM-DD"));
            this.$(".startTime .start-hour").val("0");
            this.$(".startTime .start-minute").val("0");
            this.$(".endTime .time-width").val(moment().format("YYYY-MM-DD"));
            this.$(".endTime .end-hour").val(moment().format("HH").indexOf("0") == 0 ? moment().format("H") : moment().format("HH"));
            this.$(".timeEnd .end-hour").val(moment().format("HH").indexOf("0") == 0 ? moment().format("H") : moment().format("HH"));
            this.$(".endTime .end-minute").val(moment().format("mm").indexOf("0") == 0 ? moment().format("m") : moment().format("mm"));
            this.$(".timeEnd .end-minute").val(moment().format("mm").indexOf("0") == 0 ? moment().format("m") : moment().format("mm"));
            this.$(".time-width").datepicker(datei18n.datei18n[POS.getRestaurant().get('locale').toLowerCase()]);
            this.todayBills();
            this.renderAnalytics();

            if (POS.getRestaurant().get("showQuickSettings")) {
                var accessCount = DbRecorder.read("accessCount");
                if (accessCount == null) {
                    DbRecorder.save("accessCount", 1);
                } else if (parseInt(accessCount) == 1) {
                    DbRecorder.save("accessCount", parseInt(accessCount) + 1);
                }
                if (parseInt(accessCount) > 1) {
                    this.renderQuickTips();
                }
            }
            if (this.settingTag.length != 0) {
                $(".nav-tabs").find("." + this.settingTag).click();
            }

            //默认选择当日账单统计
            this.$('li.record').click();
            return this;
        },

        hiddenExportTip: function () {
            this.$('.alert').empty();
            this.$('.alert').addClass('hidden');
        },
        renderQuickTips: function () {
            // this.$(".quickModal").show();
        },
        _close: function (evt) {
            var self = this, jxhr;
            if ($(evt.currentTarget).hasClass("noTip")) {
                jxhr = $.post("/pos/noTip", {id: POS.getRestaurant().get("id")});
                jxhr.done(function (response) {

                });
                jxhr.fail(function (response) {

                });
            }
            self.$(".quickModal").hide();
        },
        exportData: function (evt) {
            var targetBtn = $(evt.currentTarget);
            this.hiddenExportTip();
            this.$('.has-error').removeClass('has-error');
            this.$('.help-block').text('');
            var symd = $(".export .startTime .form-control").val().split("-"),
                eymd = $(".export .endTime .form-control").val().split("-");
            var start = {
                    year: symd[0],
                    mouth: symd[1],
                    day: symd[2],
                    hour: $('.startTime .start-hour').val(),
                    minute: $('.startTime .start-minute').val()
                },
                end = {
                    year: eymd[0],
                    mouth: eymd[1],
                    day: eymd[2],
                    hour: $('.endTime .end-hour').val(),
                    minute: $('.endTime .end-minute').val()
                },
                params = {id: POS.get('rId')}, listener = new Backbone.Model(), self = this;

            start = new Date(start.year, parseInt(start.mouth) - 1, start.day, start.hour, start.minute, 0).getTime();
            end = new Date(end.year, parseInt(end.mouth) - 1, end.day, end.hour, end.minute, 0).getTime();
            if (start > end) {
                this.$('.form-group').addClass('has-error');
                this.$('.help-block').text(i18n.msg("pos.setting.sales.invalidTimeRange"));
                return false;
            }

            if (((end - start) / (24 * 60 * 60 * 1000) > 35) && !$(evt.target).hasClass('email')) {
                this.$('.form-group').addClass('has-error');
                this.$('.help-block').text("超过35天的数据请选择邮件发送");
                return false;
            }

            params.startStr = moment(start).format('YYYY/MM/DD HH:mm');
            params.endStr = moment(end).format('YYYY/MM/DD HH:mm');

            targetBtn.parent().find('button.download').prop('disabled', 'true');
            targetBtn.parent().find('button.email').prop('disabled', 'true');
            targetBtn.parent().find('button.print-record').prop('disabled', 'true');
            targetBtn.parent().find('button.downloadMail').prop('disabled', 'true');
            this.$('.downloadExplanation').removeClass('hidden');
            var limitTime = 5;
            var showTime = function (currentTime) {
                currentTime--;
                setTimeout(function () {
                    if (currentTime != 0) {
                        this.$('.downloadExplanation').text(i18n.msg("pos.setting.sales.download.explanation", currentTime + ''));
                        showTime(currentTime);
                    } else {
                        targetBtn.parent().find('button.download').removeAttr('disabled');
                        targetBtn.parent().find('button.email').removeAttr('disabled');
                        targetBtn.parent().find('button.print-record').removeAttr('disabled');
                        targetBtn.parent().find('button.downloadMail').removeAttr('disabled');
                        this.$('.downloadExplanation').addClass('hidden');
                    }
                }, 1000);
            }
            this.$('.downloadExplanation').removeClass("hidden").text(i18n.msg("pos.setting.sales.download.explanation", limitTime + ""));
            showTime(limitTime);

            if ($(evt.target).hasClass('email')) {
                params.email = true;
                if ((end - start) / (24 * 60 * 60 * 1000) > 365) {
                    this.$('.form-group').addClass('has-error');
                    this.$('.help-block').text("发送数据不可大于一年");
                    return false;
                }
                var result = $.post('/restaurant/exportSalesRecordForEmail', params);

                result.done(function (res) {
                    var msg = self.$('.alert').removeClass('hidden');
                    if (res.success) {
                        msg.addClass('alert-success').text("您的数据正在统计,请稍后前往邮箱" + POS.getUser().email + "查看");

                    } else {
                        msg.addClass('alert-error').text(res.errors ? res.errors : i18n.msg('pos.setting.sales.emailError'));
                    }
                });

                result.fail(function (res) {
                    self.$('.alert').addClass('alert-error').removeClass('hidden').text(i18n.msg('pos.setting.sales.emailError'));
                });

            } else {
                $(".download-frame").remove();
                var href = '/restaurant/exportSalesRecord?' + "startStr=" + params.startStr + "&endStr=" + params.endStr + "&id=" + params.id + "&mail=" + $(evt.target).hasClass('downloadMail');
                var frame = $('<iframe class="download-frame" style="visibility: hidden;position: absolute;left: -10000px;top: 0;" width="0" height="0" frameborder="0" src="' + href + '"></iframe>');
                frame.appendTo($("body"));
            }
            return false;
        },

        showDownloadExplanation: function () {
            this.$('.downloadExplanation').text(i18n.msg("pos.setting.sales.download.explanation", time + ''))
            setTimeout("showDownloadExplanation()", 1000);
        },

        selectPanel: function (evt) {
            var panel = $(evt.currentTarget);
            this.$('.nav li').removeClass('active');
            panel.addClass('active');

            if (panel.find('a').hasClass('export')) {
                this.$('div.export').removeClass('hidden');
                this.$('div.today,div.analytics,div.topItems,div.analyticsData,div.export-takeout').addClass('hidden');
            } else if (panel.find('a').hasClass('analytics')) {
                this.$('div.analytics').removeClass('hidden');
                this.$('div.export,div.today,div.topItems,div.analyticsData,div.export-takeout').addClass('hidden');
            } else if (panel.find('a').hasClass('topItems')) {
                this.$('div.topItems').removeClass('hidden');
                this.$('div.export,div.today,div.analytics,div.analyticsData,div.export-takeout').addClass('hidden');
            } else if (panel.find('a').hasClass('analyticsData')) {
                this.$('div.analyticsData').removeClass('hidden');
                this.$('div.export,div.today,div.analytics,div.topItems,div.export-takeout').addClass('hidden');
            } else if (panel.find('a').hasClass('export-takeout')) {
                this.$('div.export-takeout').removeClass('hidden');
                this.$('div.export,div.today,div.analytics,div.topItems').addClass('hidden');
            } else {
                this.$('div.today').removeClass('hidden');
                this.$('div.export,div.analytics,div.topItems,div.analyticsData,div.export-takeout').addClass('hidden');
                this.todayBills();
            }

            this.hiddenExportTip();
        },

        anchorClicked: function (e) {
            window.location.href = $(e.target).attr("href");
            return false;
        },

        todayBills: function () {
            var bills = [], jxhr, self = this;
            var params = {
                    bills: [],
                    showTableName: true,
                    showTodayTotal: !(POS.getRestaurant().get("staffCashier") && !POS.getUser().isAdmin),
                    showSearchBar: true
                },
                tmpl = BillList,
                printable = POS.getPrinterSetting().isPrintable(),
                currency = POS.getRestaurant().get("currencySymbol"), total = 0;
            var viewHeight = $(window).height() - 180 - self.$('.nav-tabs').height() - self.$('.today thead').height();
            var pagingModel = new PagingModel({viewHeight: viewHeight, rowSize: 1, rowHeight: 62});

            jxhr = $.post('/bill/todayBills', {id: POS.getRestaurant().id});
            jxhr.done(function (response) {
                if (response.success) {
                    bills = response.bills;
                    params.size = bills.length;
                    params.showPaging = (bills.length > pagingModel.get("pageSize"));
                    _.each(bills, function (bill, i) {
                        var itemCount = 0;
                        bill.refundable = (bill.refundStatus != "Total" && !bill.hasComment);
                        bill.refundstatus = (bill.refundStatus == "Total");
                        bill.hasRefund = (bill.refundStatus != "Total");
                        _.each(bill.items, function (item) {
                            itemCount += item.orderedQuantity;
                        });
                        bill.time = new moment(bill.orderDate ? bill.orderDate : bill.checkInDate).format('HH:mm');
                        bill.tableName = bill.table.name;
                        bill.tid = bill.table.id;
                        bill.itemCount = itemCount;
                        total += bill.originalShouldPayAmount;
                        if (bill.transaction) {
                            bill.onlinePayRefundable = bill.transaction.totalRefund < bill.transaction.totalAmount;
                        }
                    });
                    self.todayBillCollection = new BillCollection(bills);
                    params.bills = self.todayBillCollection.toJSON().reverse();
                    params.printable = printable;
                    params.total = total;
                    params.showEmptyLabel = params.bills.length == 0;
                    console.log(params);
                    self.$('div.today').empty().append(
                        tmpl(params)
                    );
                    pagingModel.setItemSize(self.$('.today tr.bill').size());

                    self.billPageView = new PagingView({
                        el: self.$('.table'), pagingControl: self.$('.today .paging'),
                        model: pagingModel
                    });
                    self.billPageView.render();
                }


            });

            jxhr.fail(function (res) {
                alert(i18n.msg('pos.serverError'));
                console.error(res);
            });
        },

        showBillPopup: function (evt) {
            var bill, billItem = $(evt.currentTarget), shallow = billItem.hasClass("shallow");

            if (billItem.data('id')) {
                bill = this.todayBillCollection.find({id: billItem.data("id")});
            }
            if (!bill) {
                return;
            }
            this.model.unset("searchBill");
            this.createBillPopup(bill, shallow);
        },
        showRefundPage: function () {
            var modal = this.$('.billModal'), modalBody = modal.find('.modal-body');
            modalBody.find('.refunds').show();
            modalBody.find('.item-foot').show();
            modalBody.find('.title').hide();
            modalBody.find(".item-selected:not('.hasRefund')").removeClass("hidden");
            if (modalBody.find(".item-body.disablecheck").length > 0) {
                modalBody.find('.item-selected .item-checked').removeClass('hidden');
                modalBody.find('.item-selected .item-unchecked').addClass('hidden');
            } else {
                modalBody.find('.item-selected .item-checked').addClass('hidden');
                modalBody.find('.item-selected .item-unchecked').removeClass('hidden');
            }
            modalBody.siblings('.modal-header').hide();
        },

        hideRefundPage: function () {
            var modal = this.$('.billModal'), modalBody = modal.find('.modal-body');
            modalBody.find('.refunds').hide();
            modalBody.find('.item-foot').hide();
            modalBody.find('.title').show();
            modalBody.find('.item-selected').addClass('hidden');
            modalBody.siblings('.modal-header').show();
        },
        createBillPopup: function (bill, shallow) {
            var modal = this.$('.billModal'), modalBody = modal.find('.modal-body'),
                bill = DbRecorder.convert2JSON(bill),
                symbol = POS.getRestaurant().get("currencySymbol"), modalTitleEle = modal.find('.modal-title');
            modalTitleEle.text(i18n.msg('pos.printer.receipt.bill.sid') + " " + bill.sid + " (" + bill.shortUUID + ")");
            modal.removeClass('billModal');
            modal.attr('data-sid', bill.sid);
            modal.attr('data-tid', bill.tid);
            modal.attr('data-id', bill.id).attr('data-cid', bill.cid).modal();
            modalBody.find('.row:first').empty();
            modal.addClass('billModal');
            var items = [];
            var json = bill;
            $.each(bill.items, function (index, value) {
                console.log(value);
                var jsonItem = value;
                jsonItem.cid = value.cid;
                jsonItem._status = "pos.bill.item.status." + jsonItem.status.toLowerCase();
                if (_.isNumber(jsonItem.price)) {
                    jsonItem.itemPrice = symbol + jsonItem.price;
                }
                jsonItem.shallow = shallow;
                items.push(jsonItem);
            });
            var method = "";
            $.each(bill.payments, function (index, value) {
                if (value.type == "Payment") {
                    if (value.method == "IGNORE" || value.method == "TIP") {
                        return;
                    }
                    switch (value.method) {
                        case "MEMBER_CARD":
                            method += i18n.msg("pos.payment.method.MEMBER_CARD");
                            break;
                        case "WEIXIN_POS":
                            method += i18n.msg("pos.payment.method.WECHAT");
                            break;
                        case "ALIPAY_POS":
                            method += i18n.msg("pos.payment.method.ALIPAY");
                            break;
                        case "CASH":
                            method += i18n.msg("pos.payment.method.CASH");
                            break;
                        case "CUSTOM":
                            method += i18n.msg("pos.payment.method.OTHER_PAY");
                            break;
                        case "CREDIT_CARD":
                            method += i18n.msg("pos.payment.method.CREDIT_CARD");
                            break;
                        case "ALIPAY":
                            method += i18n.msg("pos.payment.method.ALIPAY");
                            break;
                        case "WEIXIN":
                            method += i18n.msg("pos.payment.method.WECHAT");
                            break;
                        case "COUPON":
                            method += i18n.msg("pos.payment.method.COUPON");
                            break;
                        case "OTHER_PAY":
                            method += i18n.msg("pos.payment.method.OTHER_PAY");
                            break;
                        default:
                            method += i18n.msg("pos.payment.method.CASH");
                            break;
                    }
                    if (value.customPayment) {
                        method = value.customPayment.name;
                    }
                    method += "  "
                }
            });
            json.paymentMethod = method;
            var payments = bill.payments.reduce(function (initvalue, payment) {
                if (payment.type == "Payment") {
                    initvalue.push(payment);
                }
                return initvalue;
            }, []);
            //var payments = bill.get("payments").filter(function(a){return a.get('type')=="Payment"});
            json.items = items;
            if (payments.length > 1 || bill.transaction) {
                json.disablecheck = true
            } else {
                json.disablecheck = false
            }
            modalBody.find('.row:first').append(BillDetails(json));
            modalBody.find('.refunds').hide();
            modalBody.find('.item-foot').hide();
        },

        refundBill: function (bill, items, billItem, reason) {
            var self = this, jxhr, data, itemsRefund = [], restaurant = POS.get("restaurant");
            var printSetting = POS.getPrinterSetting(), status = "Has";
            if (!items) {
                status = "Total";
                items = bill.items;
            }
            if (items.length == bill.items.length) {
                status = "Total";
            }
            items.forEach(function (item) {
                console.log("should refund", item);
                itemsRefund.push({id: item.id, reason: reason, paid: item.paid});
            });


            //离线后同步，将bill的折扣信息传到后台，用于后台计算带有折扣的订单的退款金额
            data = {
                id: bill.id,
                restaurantId: restaurant.id,
                reason: reason,
                discountId: bill.discount ? bill.discount.id : 0,
                jsonItems: JSON.stringify(itemsRefund),
                refundStatus: status
            };

            jxhr = $.post("/bill/refunds", data);
            jxhr.done(function (response) {
                if (response.success) {
                    self.$('.billModal').modal('hide');
                    self.todayBills();
                    if (restaurant.fastFood) {
                        bill.fastfood = true;
                    }
                    bill.table = (POS.getTable(bill.table.id)).toJSON();
                    if (printSetting.get("returnSlip")) {
                        _.each(response.items, function (item) {
                            PrintService.printItemReceipts(bill, item, "Refund");
                        });
                    }
                    return;
                }
            });
            jxhr.fail(function (response) {
                console.log("Refund bill " + bill.id + " failed");
            });
        },

        showRefundPopup: function (bill, items, billItem) {
            var confirmModel = new Backbone.Model({}), self = this;

            confirmModel.on("change:shouldConfirm", function (m) {

                confirmModel.set({confirmed: true});

                var jxhr, data, itemsRefund = [], restaurant = POS.get("restaurant");
                if (!items) {
                    items = bill.items;
                }

                items.forEach(function (item) {
                    console.log("should refund", item);
                    itemsRefund.push({id: item.id, reason: m.get("reason"), paid: item.paid});
                });


                //离线后同步，将bill的折扣信息传到后台，用于后台计算带有折扣的订单的退款金额
                data = {
                    id: bill.id,
                    restaurantId: restaurant.id,
                    reason: m.get("reason"),
                    discountId: bill.discount ? bill.discount.id : 0,
                    jsonItems: JSON.stringify(items)
                };

                jxhr = $.post("/bill/refunds", data);
                jxhr.done(function (response) {
                    if (response.success) {
                        self.$('.billModal').modal('hide');
                        self.todayBills();
                        if (restaurant.fastFood) {
                            bill.fastfood = true;
                        }
                        if (printSetting.get("returnSlip")) {
                            _.each(items, function (item) {
                                PrintService.printItemReceipts(bill, item, "Refund");
                            });
                        }
                        return;
                    }
                });
                jxhr.fail(function (response) {
                    console.log("Refund bill " + bill.id + " failed");
                });
            });
            new BillRefundModalView({model: confirmModel}).render();
        },

        refundSearchBill: function (bill) {
            var jxhr, self = this, data, items = [], restaurant = POS.get("restaurant");
            bill.getBillItems().forEach(function (item) {
                if (item.get("shouldRefund")) {
                    console.log("should refund", item);
                    items.push({id: item.id, reason: item.get("refundNote"), paid: item.get("paid")});
                }
            });
            if (items.length < 1 || !bill.id || bill.getProcessing()) {
                return;
            }
            bill.setProcessing();
            //离线后同步，将bill的折扣信息传到后台，用于后台计算带有折扣的订单的退款金额
            data = {
                id: bill.id,
                restaurantId: restaurant.id,
                reason: bill.get("refundReason"),
                discountId: bill.get("discount") ? bill.get("discount").id : 0,
                jsonItems: JSON.stringify(items)
            };
            console.log("refunding bill", data);
            jxhr = $.post("/bill/refunds", data);
            jxhr.done(function (response) {
                if (!response.success) {
                    console.log(response);
                    return;
                }
            });
            jxhr.fail(function (response) {
                console.log("Refund bill " + bill.id + " failed");
            });
            jxhr.always(function (response) {
                bill.unsetProcessing();
            });
            return jxhr;
        },

        printSearchBill: function (evt) {
            var self = this, bill = self.model.get("searchBill");
            var table;
            if (bill) {
                table = POS.getTable(bill.get('table').id);
            } else {
                table = POS.getTable($(evt.currentTarget).data('tid'));
                bill = this.todayBillCollection.find({'id': $(evt.currentTarget).data('id')});
            }
            var printActionsView = new BillPrintActionsView({
                el: self.printEL,
                bill: bill,
                table: table,
                model: new Backbone.Model({})
            });
            var printActionsViewModal = new ModalView({
                body: printActionsView.el,
                title: i18n.msg("pos.printer.receipt.type.selection.label"),
                save: i18n.msg("pos.label.print")
            }).render();
            printActionsViewModal.$el.find(".modal-content").addClass("printActionModal");
            printActionsViewModal.$el.find(".btn-confirm").addClass("printAction");
            printActionsViewModal.model.on("change:confirmedTime", function () {
                printActionsView._print();
                printActionsViewModal.close();
            });
            printActionsViewModal.model.on("change:closeTime", function () {
                printActionsViewModal.close();
            });
            return false;
        },
        _antiSettlement: function (billItem) {
            var bill;
            if (!confirm("确认反结账该笔订单吗?")) {
                return false;
            }
            if (billItem.data('id')) {
                bill = this.todayBillCollection.find({'id': billItem.data('id')});
            }
            let jxhr = $.post("/bill/antiSettlementBill", {id: bill.id});
            jxhr.done(function (response) {
                if (response.success) {
                    console.log(response.bill);
                    let table = POS.getTable(response.bill.table.id);
                    if (table) {
                        var bills = table.getBillCollection();
                        var currentBill = table.getCurrentBill();
                        var localBill = currentBill && currentBill.id == bill.id ? currentBill : bills.get(bill.id);
                        if (localBill) {
                            console.log(new Date() + " SYNC: local bill " + bill.id + " exist and version differs (" + localBill.get('version') + " vs " + bill.version + ")- merge with local db");
                            BillMerger.merge(localBill, new BillModel(response.bill));
                        } else {
                            // bill not found on this table.
                            console.log(new Date() + " SYNC: local bill " + bill.id + " doesn't exist anywhere - add to local db");
                            var billModel = new BillModel(bill);
                            bills.add(billModel);
                            table.trigger("change");
                        }
                        Backbone.history.navigate("table/" + table.id, {trigger: true});
                    }
                }
            });
            jxhr.fail(function (response) {

            });
            return false;
        },
        antiSettlement: function (evt) {
            let self = this,
                btn = $(evt.currentTarget),
                billItem = btn.closest(".bill"),
                table = POS.getTable(billItem.data('tid')),
                bill,
                user = POS.getUser();
            if (!POS.getUser().isAdmin && false) {
                var admins = POS.getRestaurantAdmins();
                var passwordEntryEl = $(PasswordEntry({admins: admins}));
                var model = new Backbone.Model();
                var passwordEntry = new PasswordEntryView({el: passwordEntryEl, model: model});
                var passwordModalView = new ModalView({
                    body: passwordEntryEl,
                    hideFooter: true
                }).render();
                passwordModalView.$el.find('.modal-content').addClass('passwordModal');
                passwordModalView.listenToOnce(model, "confirm", function () {
                    self._antiSettlement(billItem);
                    passwordModalView.close();
                });
                passwordModalView.listenToOnce(model, "cancel", passwordModalView.close, passwordModalView);
            } else {
                self._antiSettlement(billItem);
            }
            return false;
        },
        printBill: function (evt) {
            var self = this,
                btn = $(evt.currentTarget),
                billItem = btn.closest(".bill"),
                table = POS.getTable(billItem.data('tid')),
                bill;
            if (billItem.data('id')) {
                bill = this.todayBillCollection.find({'id': billItem.data('id')});
            }
            var printActionsView = new BillPrintActionsView({
                el: self.printEL,
                bill: bill,
                table: table,
                model: new Backbone.Model({})
            });
            var printActionsViewModal = new ModalView({
                body: printActionsView.el,
                title: i18n.msg("pos.printer.receipt.type.selection.label"),
                save: i18n.msg("pos.label.print")
            }).render();
            printActionsViewModal.$el.find(".modal-content").addClass("printActionModal");
            printActionsViewModal.$el.find(".btn-confirm").addClass("printAction");
            printActionsViewModal.model.on("change:confirmedTime", function () {
                printActionsView._print();
                printActionsViewModal.close();
            });
            printActionsViewModal.model.on("change:closeTime", function () {
                printActionsViewModal.close();
            });
            return false;
        },
        printRecord: function (evt) {
            var targetBtn = $(evt.currentTarget);
            var self = this, jxhr,
                symd = $(".startTime .form-control").val().split("-"),
                eymd = $(".endTime .form-control").val().split("-"),
                printBtn = self.$(".btn.print-record"),
                start = {
                    year: symd[0],
                    mouth: symd[1],
                    day: symd[2],
                    hour: $('.startTime .start-hour').val(),
                    minute: $('.startTime .start-minute').val()
                },
                end = {
                    year: eymd[0],
                    mouth: eymd[1],
                    day: eymd[2],
                    hour: $('.endTime .end-hour').val(),
                    minute: $('.endTime .end-minute').val()
                },
                params = {id: POS.get('rId')};
            if (printBtn.hasClass("disabled")) {
                return false;
            }
            printBtn.addClass("disabled");
            start = new Date(start.year, parseInt(start.mouth) - 1, start.day, start.hour, start.minute, 0).getTime();
            end = new Date(end.year, parseInt(end.mouth) - 1, end.day, end.hour, end.minute, 0).getTime();
            if (start > end) {
                this.$('.form-group').addClass('has-error');
                this.$('.help-block').text(i18n.msg("pos.setting.sales.invalidTimeRange"));
                return false;
            }
            if ((end - start) / (24 * 60 * 60 * 1000) > 60) {
                this.$('.form-group').addClass('has-error');
                this.$('.help-block').text(i18n.msg("pos.setting.sales.invalidTimeRange.60days"));
                return false;
            }
            self.$(".btn.print-record").addClass("disabled");
            params.startStr = moment(start).format('YYYY/MM/DD HH:mm');
            params.endStr = moment(end).format('YYYY/MM/DD HH:mm');
            targetBtn.parent().find('button.download').prop('disabled', 'true');
            targetBtn.parent().find('button.email').prop('disabled', 'true');
            targetBtn.parent().find('button.print-record').prop('disabled', 'true');
            this.$('.downloadExplanation').removeClass('hidden');
            var limitTime = 5;
            var showTime = function (currentTime) {
                currentTime--;
                setTimeout(function () {
                    if (currentTime != 0) {
                        this.$('.downloadExplanation').text(i18n.msg("pos.setting.sales.download.explanation", currentTime + ''));
                        showTime(currentTime);
                    } else {
                        targetBtn.parent().find('button.download').removeAttr('disabled');
                        targetBtn.parent().find('button.email').removeAttr('disabled');
                        targetBtn.parent().find('button.print-record').removeAttr('disabled');
                        this.$('.downloadExplanation').addClass('hidden');
                    }
                }, 1000);
            }
            this.$('.downloadExplanation').removeClass("hidden").text(i18n.msg("pos.setting.sales.download.explanation", limitTime + ""));
            showTime(limitTime);
            jxhr = $.post("/restaurant/receipt", params);
            jxhr.done(function (response) {
                console.log('printBusinessRecord', response);
                console.log('printBusinessRecordParams', params);
                if (!response.success) {
                    return;
                }
                PrintService.printBusinessRecords(response.bills, params);
            });

            jxhr.always(function () {
                printBtn.removeClass("disabled");
            });
            return true;
        },

        renderPopularChart: function () {
            var itemCount = StatsService.getItemCount(), pieData = [],
                colours = ["#FAD35C", "#F26257", "#E1F8F2", "#92CF67", "#58A4C6"],
                legends = this.$('.chartLabels'), i = 0, total = StatsService.getTotalItemSold();

            _.each(itemCount, function (count, name) {
                pieData.push({value: count, name: name});
            });

            var pieData = _.sortBy(pieData, function (item) {
                return item.value;
            }).reverse();

            var topPieData = pieData.splice(0, 3);

            if (topPieData.length + pieData.length > 3) {
                topPieData.push({
                    value: _.reduce(pieData, function (a, b) {
                        return a + b.value;
                    }, 0), name: i18n.msg('pos.setting.sales.topItems.others'),
                    color: "#E0E4CC"
                });
            }

            for (var i = 0; i < topPieData.length; i++) {
                topPieData[i].color = colours[i];
                $('<div/>', {
                    text: topPieData[i].name + ' (' + topPieData[i].value + ')',
                    style: 'background-color: ' + topPieData[i].color
                }).appendTo(legends);
            }

            this.$("#popChartInTab").attr('height', this.$el.parent().height() * 0.40)                  //导航栏里面的热门餐品统计
                .attr('width', this.$el.width() * 0.8);
            var pieCtxInTab = this.$("#popChartInTab").get(0).getContext("2d");
            new Chart(pieCtxInTab).Pie(topPieData, {animation: false});
        },

        renderAnalytics: function () {
            if ($.isEmptyObject(StatsService.getItemCount())) {
                this.$('.topItems .chart p').text(i18n.msg('pos.setting.sales.topItems.noBill'));
            } else {
                this.renderPopularChart();
            }
            this.$("#salesHrChart").attr('height', this.$el.parent().height() * 0.40)
                .attr('width', this.$el.width() * 0.9);
            var ctx = this.$("#salesHrChart").get(0).getContext("2d"),
                chart, data, labels = [], values = [], chartData = StatsService.getRevenueByHour();

            for (var i = 0; i <= 23; i++) {
                labels.push(i);
                values.push(chartData[i] ? chartData[i] : 0);
            }

            data = {
                labels: labels,
                datasets: [
                    {
                        fillColor: "rgba(151,187,205,0.5)",
                        strokeColor: "rgba(151,187,205,1)",
                        data: values
                    }
                ]
            };

            var maxValueInt = Math.ceil(_.max(values));
            var yTopNum = Math.ceil(maxValueInt.toString()[0]) + 1;
            for (var i = 1; i < maxValueInt.toString().length; i++) {
                yTopNum = yTopNum + "0"
            }
            new Chart(ctx).Bar(data, {
                scaleOverride: true,
                scaleSteps: 10,
                scaleStepWidth: yTopNum / 10,
                animation: false
            });
        },

        billSearch: function () {
            var sid = this.$('.searchBar input').val(), jxhr;
            var bill = this.$(".tablecontainer table tr[data-sid='" + sid + "']");
            if (bill.length == 1) {
                bill.click();
                return;
            }
            jxhr = $.post('/bill/search', {sid: sid, restaurantId: POS.getRestaurant().get("id")});
            var printable = POS.getPrinterSetting().isPrintable(), currency = POS.getRestaurant().get("currencySymbol");
            jxhr.done(function (response) {
                this.model.unset("searchBill");
                if (!response.sid) {
                    alert(i18n.msg('pos.setting.sales.search.noResult'));
                } else {
                    var bill = response, itemCount = 0;
                    bill.refundable = (bill.refundStatus != "Total" && !bill.hasComment);
                    bill.hasRefund = (bill.refundStatus != "Total");
                    _.each(bill.items, function (item) {
                        itemCount += item.orderedQuantity;
                    });
                    bill.itemCount = itemCount;
                    var item = new BillModel(bill);
                    this.model.set({searchBill: item});
                    this.createBillPopup(bill, false);
                }

            }.bind(this));

            jxhr.fail(function (res) {
                alert(i18n.msg('pos.serverError'));
                console.error(res);
            });
        },

        selectAll: function (evt) {
            var selectAll = $(evt.currentTarget);
            if (selectAll.closest(".item-foot").siblings(".item-body").hasClass("disablecheck")) {
                return;
            }
            _.each($(".item-body .orderitem:not(.hasRefund)"), function (item) {
                if (selectAll.hasClass("selected")) {
                    $(item).removeClass("selected").find(".item-unchecked").removeClass("hidden");
                    $(item).removeClass("selected").find(".item-checked").addClass("hidden");
                    selectAll.prop("src", require("../../images/pos/settings/itemUnchecked.png"));
                } else {
                    $(item).addClass("selected").find(".item-unchecked").addClass("hidden");
                    $(item).addClass("selected").find(".item-checked").removeClass("hidden");
                    selectAll.prop("src", require("../../images/pos/settings/itemChecked.png"));
                }
            });
            selectAll.toggleClass('selected');
        },
        onBillItemClick: function (evt) {
            if ($(evt.currentTarget).hasClass('hasRefund') || $(evt.currentTarget).closest('.item-body').hasClass('disablecheck')) {
                return;
            }
            if ($(evt.currentTarget).find(".item-selected").hasClass('hidden')) {
                return;
            }
            if ($(evt.currentTarget).hasClass("selected")) {
                $(evt.currentTarget).find(".item-selected .item-checked").addClass("hidden");
                $(evt.currentTarget).find(".item-selected .item-unchecked").removeClass("hidden");
            } else {
                $(evt.currentTarget).find(".item-selected .item-checked").removeClass("hidden");
                $(evt.currentTarget).find(".item-selected .item-unchecked").addClass("hidden");
            }
            $(evt.currentTarget).toggleClass('selected');
            this.checkItemSelect();
        },
        checkItemSelect: function () {
            var items = _.filter(this.$(".item-body .pitem"), function (item) {
                return !$(item).hasClass("selected") && !$(item).hasClass("hasRefund")
            });
            if (items.length > 0) {
                $(".item-foot .selected-all").removeClass('selected').prop("src", require("../../images/pos/settings/itemUnchecked.png"));
            } else {
                $(".item-foot .selected-all").addClass('selected').prop("src", require("../../images/pos/settings/itemChecked.png"));
            }
        },

        _refundOnlinePay: function () {
            var self = this;
            if (!POS.getUser().isAdmin && POS.getRestaurant().get('staffCashier')) {
                var admins = POS.getRestaurantAdmins();
                var passwordEntryEl = $(PasswordEntry({admins: admins}));
                var model = new Backbone.Model();
                var passwordEntry = new PasswordEntryView({el: passwordEntryEl, model: model});
                var passwordModalView = new ModalView({
                    body: passwordEntryEl,
                    hideFooter: true
                }).render();
                passwordModalView.$el.find('.modal-content').addClass('passwordModal');
                passwordModalView.listenToOnce(model, "confirm", function () {
                    self.refundOnlineBill();
                    passwordModalView.close();
                });
                passwordModalView.listenToOnce(model, "cancel", passwordModalView.close, passwordModalView);
            } else {
                this.refundOnlineBill();
            }
            return false;
        },

        refundOnlineBill: function () {
            var self = this;
            var id = this.$('.billModal').attr('data-id'), jxhr, bill;
            bill = this.todayBillCollection.find({id: parseInt(id)});
            if (!bill) {
                return;
            }
            console.log("refund online paid", bill);
            jxhr = $.post("/bill/refundOnlinePay", {billId: bill.id});
            jxhr.done(function (response) {
                if (response.success) {
                    self.$('.billModal').modal('hide');
                    self.todayBills();
                    return;
                }
            });
            jxhr.fail(function (response) {
            });
        },
        _refundItems: function () {
            var self = this;
            if (!POS.getUser().isAdmin && POS.getRestaurant().get('staffCashier')) {
                var admins = POS.getRestaurantAdmins();
                var passwordEntryEl = $(PasswordEntry({admins: admins}));
                var model = new Backbone.Model();
                var passwordEntry = new PasswordEntryView({el: passwordEntryEl, model: model});
                var passwordModalView = new ModalView({
                    body: passwordEntryEl,
                    hideFooter: true
                }).render();
                passwordModalView.$el.find('.modal-content').addClass('passwordModal');
                passwordModalView.listenToOnce(model, "confirm", function () {
                    self.refundItems();
                    passwordModalView.close();
                });
                passwordModalView.listenToOnce(model, "cancel", passwordModalView.close, passwordModalView);
            } else {
                this.refundItems();
            }
            return false;
        },

        refundItems: function () {
            var sid = this.$('.billModal').attr('data-sid'), tid = this.$('.billModal').attr('data-tid'),
                id = this.$('.billModal').attr('data-id'), billList = this.todayBillCollection, bill, reason = "";
            bill = this.todayBillCollection.find({id: parseInt(id)});
            var refundItemCidList = _.map(this.$('.billModal .orderitem.selected'), function (item) {
                return $(item).data('id')
            }), billItemEle;

            if (bill) {
                billItemEle = this.$('.today .bill[data-id="' + bill.id + '"]');
            }

            if (!bill && this.model.get('searchBill')) {
                bill = this.model.get('searchBill');
            }
            if (!bill) {
                return;
            }
            if (this.$(".billModal .reason input:checked").data("reason") == "other") {
                if (this.$(".billModal .other-reason").val() == "" || typeof this.$(".billModal .other-reason").val() == 'undefined') {
                    alert(i18n.msg("pos.table.modal.refund.empty"));
                    return
                }
                reason = this.$(".billModal .other-reason").val();
            } else {
                reason = this.$(".billModal .reason input:checked").val();
            }
            console.log(reason);
            bill = DbRecorder.convert2JSON(bill);
            if (this.$('.billModal .selected-all.selected').length > 0) {
                bill.refundStatus = 'Total';
            }
            if (refundItemCidList.length > 0) {
                var refundItems = _.filter(bill.items, function (item) {
                    return refundItemCidList.indexOf(item.id) >= 0;
                });
                this.refundBill(bill, refundItems, billItemEle, reason);

            } else {
                if (confirm(i18n.msg('pos.setting.sales.refund.all'))) {
                    this.refundBill(bill, null, billItemEle, reason);
                }
            }
        }
    });
};

let exportedValue = main();
export default exportedValue;



// WEBPACK FOOTER //
// ./src/view/settings/SalesExportView.js